import styled from 'styled-components'

import breakpoints from '../../theme/breakpoints'
import FormikForm from '../form/FormikForm'
import FormFieldSelect from '../form/fields/FormFieldSelect'
import FormFieldInput from '../form/fields/FormFieldInput'
import FormFieldToggleButtonGroup from '../form/fields/FormFieldToggleButtonGroup'

export const Container = styled.div``
export const Form = styled(FormikForm)``

export const Description = styled.p`
  ${({ theme }) => theme.textStyles.textMedium}
  color: ${({ theme }) => theme.colors.nightRider};
  margin: 0rem 0 2.4rem 0;
  font-size: 1.4rem;
  line-height: 1.5;
`

export const RelationshipSelect = styled(FormFieldSelect)`
  width: 100%;
  max-width: 32rem;
`

export const RelationshipRow = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1.6rem;

  ${breakpoints.up('tablet')} {
    gap: 2.4rem;
  }
`

export const ToggleGroup = styled(FormFieldToggleButtonGroup)``

export const Select = styled(FormFieldSelect)`
  width: 35%;

  ${breakpoints.up('tablet')} {
    width: 15%;
  }
`

export const Inputs = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 2.4rem 0;
  gap: 1.6rem;

  ${breakpoints.up('tablet')} {
    margin: 4rem 0;
    gap: 2.4rem;
  }
`

export const Input = styled(FormFieldInput)`
  max-width: 32rem;
  width: 100%;
`
